import { createComponentRegistry } from '../../directives/tbSiteSettingsForServerAdminFormAdapter';
import { CacheWarmupSectionSpecs } from './sections/CacheWarmupSection';
import { CatalogingSectionSpecs } from './sections/CatalogingSection';
import { GuestAccessSpecs } from './sections/GuestAccessSection';
import { ManageUsersSectionSpecs } from './sections/manage-users-section/ManageUsersSection';
import { ManagedKeychainCleanupSectionSpecs } from './sections/ManagedKeychainCleanup';
import { PerformanceMetricsSectionSpecs } from './sections/PerformanceMetricsSection';
import { PrepConductorSpecs } from './sections/PrepConductorSection';
import { RevisionHistorySectionSpecs } from './sections/revision-history/RevisionHistorySection';
import { SiteNameAndIdSpecs } from './sections/site-name-and-id/SiteNameAndIdSection';
import { SiteAvailabilitySpecs } from './sections/SiteAvailabilitySection';
import { StorageSectionSpecs } from './sections/storage/StorageSection';
import { AutoSuspendExtractRefreshSectionSpecs } from './sections/AutoSuspendExtractRefreshSection';
import { WebAuthoringSpecs } from './sections/WebAuthoringSection';
import { EmailSettingsSpecs } from './sections/EmailSettingsSection';
import { DataAccelerationSpecs } from './sections/data-acceleration/DataAccelerationSection';
import { SiteInviteNotificationSpecs } from './sections/SiteInviteNotificationSection';
import { UserVisibilitySpecs } from './sections/UserVisibilitySection';
import { StartPageSpec } from './sections/StartPageSection';

/**
 * All react-based sections in the settings page should be added to this object to allow them to be named in
 * the pug file while migrating, and to dynamically load them later on
 */
export const SettingsComponentRegistry = createComponentRegistry(
  SiteNameAndIdSpecs,
  SiteAvailabilitySpecs,
  PrepConductorSpecs,
  WebAuthoringSpecs,
  StorageSectionSpecs,
  RevisionHistorySectionSpecs,
  ManageUsersSectionSpecs,
  GuestAccessSpecs,
  PerformanceMetricsSectionSpecs,
  CatalogingSectionSpecs,
  CacheWarmupSectionSpecs,
  ManagedKeychainCleanupSectionSpecs,
  AutoSuspendExtractRefreshSectionSpecs,
  EmailSettingsSpecs,
  DataAccelerationSpecs,
  SiteInviteNotificationSpecs,
  UserVisibilitySpecs,
  StartPageSpec
);

